import comp from "./VerificationAuthModal";
export default comp;
